import { type CommonAction, response, success } from "@iflyrpa/share";
import type { ActiomCommonParams, AxiosProxyParams } from "../../types";
import { DisabledReq } from "../../types";
import { Http } from "../../utils/http";

export interface searchXhsWebIntimacyListParams extends ActiomCommonParams {
    searchValue?: string;
}

export interface Intimacy {
    images: string;
    rid: string;
    userid: string;
    nickname: string;
}

export type PublishAction = CommonAction<searchXhsWebIntimacyListParams, Intimacy[] | []>;

export const xiaohongshuWebIntimacySearch: PublishAction = async (_task, params) => {
    if (DisabledReq) return response(0, "搜索@列表数据成功", []);
    const headers = {
        cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        referer: "https://www.xiaohongshu.com/",
        origin: "https://www.xiaohongshu.com",
    };

    const args: AxiosProxyParams = [
        { headers },
        _task.logger,
        params.proxyLoc,
        params.localIP,
        // params.huiwenToken,
        params.accountId,
    ];
    const http = new Http(...args);

    let intimacyDetail: Intimacy[] | [] = [];

    const res = await http.api<{ code: number; msg: string; data: { items: Intimacy[] } }>(
        {
            method: "get",
            url: `https://edith.xiaohongshu.com/api/sns/web/v1/intimacy/intimacy_list${params.searchValue ? "/search" : ""}`,
            ...(params.searchValue
                ? {
                      params: {
                          keyword: params.searchValue,
                          page: 1,
                          rows: 30,
                      },
                  }
                : {}),
        },
        { retries: 3, retryDelay: 20, timeout: 3000 },
    );

    const isSuccess = res.code === 0;
    if (isSuccess) intimacyDetail = res.data?.items;
    const message = `搜索@列表数据${isSuccess ? "成功" : `失败，原因：${res.msg}`}${_task.debug ? ` ${http.proxyInfo}` : ""}`;

    return response(isSuccess ? 0 : 414, message, intimacyDetail);
};
